import { createContext, use } from "react";
import type { PanelContextType } from "./types";

export const PanelContext = createContext<PanelContextType | null>(null);

export const usePanelContext = () => {
  const context = use(PanelContext);

  if (!context) {
    throw new Error("usePanelContext must be used within a Panel");
  }

  return context;
};
